// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__tH12G","lds-ring":"Loader_lds-ring__lAZyM"};